import { $t } from "@/plugins/i18n"

import { Epic } from "../Epic"
import { Item } from "../Item"
import { NotificationItem } from "./NotificationItem"

export class NotificationItemConvertedToEpic extends NotificationItem {
  constructor(props) {
    super(props)
  }

  get convertedItem(): Item {
    return this.content?.item ? new Item(this.content.item) : new Item()
  }

  get epic(): Epic {
    return this.content?.epic ? new Epic(this.content.epic) : new Epic()
  }

  get epicSequenceNumber() {
    return `E-${this.epic?.sequenceNumber ?? $t("none")}`
  }

  get epicName() {
    return this.epic?.name ?? $t("none")
  }

  get epicUrl() {
    return this.content?.epic?.url
  }

  get teamName() {
    return this.content?.teamName ?? this.convertedItem?.team?.name
  }

  get projectName() {
    return this.content?.projectName ?? this.convertedItem?.project?.name
  }
}
